import {
  AbilityBuilder,
  AbilityClass,
  AbilityTuple,
  createMongoAbility,
  MongoAbility,
  MongoQuery,
  PureAbility,
  subject as conditionalSubject,
  SubjectRawRule,
  SubjectType,
} from '@casl/ability';
import { UserInterface } from 'context/auth.context';

type UserCaslRules = {
  rules?: AppRuleInterface[];
};

export type AppRuleInterface = SubjectRawRule<
  string,
  SubjectType,
  MongoQuery<Record<string | number | symbol, unknown>>
>;

export type AppAbilityInterface = MongoAbility<
  AbilityTuple,
  MongoQuery<Record<string | number | symbol, unknown>>
>;

export type CaslPermission = {
  action: string;
  subject: string;
  conditions?: object;
};

export const AppAbility = PureAbility as AbilityClass<AppAbilityInterface>;

export const newAbility = () => {
  const { rules } = new AbilityBuilder(AppAbility);
  return new AppAbility(rules);
};

export const generateAbility = (user: UserInterface) => {
  const userRawRules: UserCaslRules = user?.caslAbilities ? JSON.parse(user.caslAbilities) : {};
  return userRawRules.rules?.length ? createMongoAbility(userRawRules.rules) : newAbility();
};

export const hasPermissions = (
  ability: AppAbilityInterface,
  action: string,
  subject: string,
  conditions?: object
) => {
  // Check for SuperTenant permission
  if (ability.can('access', 'SuperTenant')) {
    return true;
  }

  if (conditions) {
    return ability.can(action, conditionalSubject(subject, conditions));
  }
  return ability.can(action, subject);
};
